import { Checkbox } from '@mui/material';
import React from 'react';
import CheckedXIcon from '../../shared/components/CheckedXIcon';

/**
 * @typedef {object} SelectionCheckboxProps
 * @property {string} [id]
 * @property {React.ReactNode} [label]
 * @property {boolean} [disabled]
 * @property {boolean} checked
 * @property {(checked: boolean) => void} setChecked
 */

/**
 * @param {SelectionCheckboxProps} props
 */
const SelectionCheckbox = props => {
  const { id, label, checked, setChecked, disabled = false } = props;

  return (
    <div data-testid={id} className='appraisal-view-customization__checkbox-wrapper'>
      <Checkbox
        id={id}
        value={checked}
        size='small'
        checked={checked}
        disabled={disabled}
        checkedIcon={<CheckedXIcon size='small' />}
        onChange={e => setChecked(e.target.checked)}
        color='default'
      />
      <span className='checkbox-label-small'>{label}</span>
    </div>
  );
};

export default SelectionCheckbox;
